module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showBlank) ? _c('div', [_c('img', {
    attrs: {
      "src": "/static/no_plag_detected.png",
      "alt": "No Plagiarism Detected"
    }
  })]) : _c('table', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "30%",
      "vertical-align": "top"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "scroll",
      "height": "740px"
    }
  }, [_vm._l((_vm.redPlags), function(red) {
    return _c('div', {
      key: red.id,
      on: {
        "click": function($event) {
          return _vm.select(red)
        }
      }
    }, [_c('table', [_c('tr', [_c('td', [_c('div', {
      class: _vm.selected === red[red.length - 1] ?
        'red-card-selected' :
        'red-card'
    }, _vm._l((red), function(student) {
      return _c('div', {
        key: student.id
      }, [_vm._v("\n                      " + _vm._s(_vm.getName(student.name)) + "\n                    ")])
    }), 0)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "16px",
        "color": "#eb2d7c"
      }
    }, [_vm._v("\n                   " + _vm._s(red[red.length - 2]) + "%\n                ")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "red-to-yellow"
  }), _vm._v(" "), _vm._l((_vm.yellowPlags), function(yellow) {
    return _c('div', {
      key: yellow.id,
      on: {
        "click": function($event) {
          return _vm.select(yellow)
        }
      }
    }, [_c('table', [_c('tr', [_c('td', [_c('div', {
      class: _vm.selected === yellow[yellow.length - 1] ?
        'yellow-card-selected' :
        'yellow-card'
    }, _vm._l((yellow), function(student) {
      return _c('div', {
        key: student.id
      }, [_vm._v("\n                      " + _vm._s(_vm.getName(student.name)) + "\n                    ")])
    }), 0)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "16px",
        "color": "#ffcc33"
      }
    }, [_vm._v("\n                   " + _vm._s(yellow[yellow.length - 2]) + "%\n                ")])])])])
  })], 2)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "70%",
      "vertical-align": "top"
    }
  }, [(_vm.submissions.length > 0 && _vm.getCurrentRT.enable_annonymous) ? _c('table', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    on: {
      "click": function($event) {
        return _vm.flipIdentityReveal()
      }
    }
  }, [_c('tr', [_c('td', [_c('div', {
    staticClass: "eye-container",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(!_vm.hideNames) ? _c('i', {
    staticClass: "fa fa-eye"
  }) : _c('i', {
    staticClass: "fa fa-eye-slash"
  })])]), _vm._v(" "), _c('td', [(!_vm.hideNames) ? _c('span', [_vm._v("Hide Identities")]) : _c('span', [_vm._v("Reveal Identities")])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getSubmissions), function(submission) {
    return _c('div', {
      key: submission.id,
      staticClass: "plagiarism-submission-card"
    }, [_c('submission-card', {
      key: submission.id,
      staticStyle: {
        "margin-bottom": "30px"
      },
      attrs: {
        "submission": submission,
        "isInSummary": true,
        "isPlagPanel": true,
        "isAnonForPlagPanel": _vm.hideNames,
        "showVerticalDotMenu": false
      }
    })], 1)
  })], 2)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('tr', [_c('td', [_c('div', {
    staticClass: "red-square"
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "margin-left": "-10px"
    }
  }, [_c('b', [_vm._v("> 40% overlap in text")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "yellow-square"
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" 25 - 39% overlap in text")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n          Based on Latest Submission"), _c('br'), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-78439744!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/roundtableSummary/roundtableSummaryPlagiarismScore.vue
// module id = 1250
// module chunks = 61